(() => {
  if (window.spotecFavoritesMarketplaceLoaded) return;
  window.spotecFavoritesMarketplaceLoaded = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-sf-favorite-buy]');
    if (!button || button.disabled) return;
    const container = button.closest('[data-sf-favorite-purchase]');
    if (!container) return;
    const message = container.querySelector('[data-sf-favorite-message]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (message) message.textContent = 'Loading purchase options…';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(button.dataset.productUrl, location.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product URL');
      url.searchParams.set('view', 'spotec-marketplace');
      // Preserve the selected preview theme when working on an unpublished copy.
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
      if (!response.ok) throw new Error('Product unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = html.querySelector('[data-sf-favorite-marketplace]');
      if (!result || result.dataset.productId !== button.dataset.productId) throw new Error('Product mismatch');
      if (!container.isConnected) return;
      const content = document.importNode(result, true);
      const picker = content.querySelector('details');
      if (picker) picker.open = true;
      container.replaceChildren(content);
      content.querySelector('summary,a')?.focus();
    } catch (_) {
      if (container.isConnected && message) message.textContent = 'Purchase options couldn’t be loaded. Try again or open the product from its name.';
    } finally {
      clearTimeout(timeout);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
